<template>
    <div class="user_butler">
        <div class="user_center_header">
            <van-icon name="arrow-left" color="#fff" class="back_icon" @click="goBack"/>
        </div>
        <div class="user_butler_box">
            <div class="user_butler_header">
                <img class="user_butler_header_img" src="../../assets/version_1.3.6/icon.png" alt="">
                <div class="user_butler_header_title">
                    <p>您的私人交易助手</p>
                    <p>添加G买卖企业微信</p>
                </div>
            </div>
            <div class="user_butler_content">
                <div class="ubc_img_box">
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <img class="ubc_img" src="../../assets/version_1.3.6/qrcode.jpg" alt="">
                </div>
                <p class="ubc_tip">长按或截图保存二维码<br/>使用微信识别添加企业微信</p>
            </div>
            <div class="ubc_add">
                <p class="ua_tit">添加官方企业微信，管家为您提供专属服务</p>
                <!-- <p class="ua_p"><i>1</i><span>检漏情报:卖家急用钱，低于市场价20%的角色/道具，您第一批知道</span></p>
                <p class="ua_p"><i>2</i><span>您关注的【XX职业/xX装备】:一旦上架，立即微信弹提醒</span></p>
                <p class="ua_p"><i>3</i><span>交易安全助手:帮者过往交易记录，防骗指南</span></p> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserButler',
    methods: {
        goBack() {
            this.$router.back()
        }
    }
}
</script>
<style lang="less" scoped>
.user_butler {
    min-height: calc(var(--vh)*100);
    background-color: #FFEFE4;
    position: relative;
    padding-top: 4.7rem;
}
.user_center_header {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 525px;
    height: 22.5rem;
    background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
    z-index: 1;
    padding: 1rem;
    .back_icon {
        position: absolute;
        left: 1rem;
        top: 1.5rem;
        font-size: 2rem;
        cursor: pointer;
    }
}
.user_butler_box {
    width: 33.5rem;
    // height: 52.4rem;
    background-color: #fff;
    border-radius: 2.4rem;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    z-index: 10;
    .user_butler_header {
        height: 8.2rem;
        background: linear-gradient( 180deg, rgba(246, 192, 172, .47) 0%, rgba(255, 244, 237, .47) 100%);
        padding: 1.4rem 1.6rem;
        display: flex;
        .user_butler_header_img {
            width: 5.5rem;
            height: 5.5rem;
            border-radius: 50%;
            margin-right: 1rem;
        }
        .user_butler_header_title {
            padding-top: .5rem;
            color: #606060;
            p:nth-child(1) {
                font-size: 1.6rem;
                margin-bottom: .6rem;
                font-weight: 700;
            }
            p:nth-child(2) {
                font-size: 1.4rem;
            }
        }
    }
    .user_butler_content {
        height: 25.3rem;
        padding-top: 3rem;
        .ubc_img_box {
            width: 15.5rem;
            height: 15.5rem;
            border: 1px solid #f66f30;
            border-radius: 2rem;
            margin: 0 auto 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            p {
                position: absolute;
                background-color: #fff;
                &:nth-child(1) {
                    width: 11.4rem;
                    height: .4rem;
                    top: -.2rem;
                    left: 2.05rem;
                }
                &:nth-child(2) {
                    width: 11.4rem;
                    height: .4rem;
                    bottom: -.2rem;
                    left: 2.05rem;
                }
                &:nth-child(3) {
                    width: .4rem;
                    height: 11.4rem;
                    top: 2.05rem;
                    left: -.2rem;
                }
                &:nth-child(4) {
                    width: .4rem;
                    height: 11.4rem;
                    top: 2.05rem;
                    right: -.2rem;
                }
            }
            .ubc_img {
                width: 13.9rem;
                height: 13.9rem;
            }
        }
        .ubc_tip {
            font-size: 1.4rem;
            color: #a4a4a4;
            text-align: center;
        }
    }
    .ubc_add {
        // height: 18.9rem;
        background: linear-gradient( 180deg, rgba(255, 228, 210, .47) 0%, rgba(252, 253, 255, .47) 100%);
        padding-top: 1.8rem;
        .ua_tit {
            font-size: 1.5rem;
            color: #606060;
            text-align: center;
            font-weight: 700;
            margin-bottom: 1.5rem;
        }
        .ua_p {
            margin: 0 1.6rem;
            display: flex;
            align-items: flex-start;
            i {
                width: 1.2rem;
                height: 1.2rem;
                background-color: #f66f30;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 1rem;
                color: #fff;
                margin-top: .5rem;
                margin-right: .7rem;
            }
            span {
                flex: 1;
                word-break: break-all;
                line-height: 2.5rem;
                color: #a4a4a4;
                font-size: 1.2rem;
            }
        }
    }
}
</style>
